import React, { Component } from 'react'

export default WrappedComponent =>
  class extends Component {
    componentDidMount() {
      const onRequest = this.props.onRequest.bind(this)
      onRequest()
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
